import { createRequestActions } from '../utils';
import * as categoryTRTypes from './categoryTRTypes';

export const saveCategoryTRs = createRequestActions(categoryTRTypes.SAVE_CATEGORY_TRs);
export const listCategoriesTR = createRequestActions(categoryTRTypes.CATEGORY_TR_LIST);
